// Audit Log Service - API Client
// Generated for Task 15.2 - Create audit logs viewer frontend

import httpClient from '../utils/httpClient';
import {
  AuditLog,
  AuditLogFilters,
  AuditLogsResponse,
  AuditStatistics
} from '../types/auditLog';

const API_BASE = '/api/audit-logs';

function buildFilterParams(filters?: AuditLogFilters): string {
  if (!filters) return '';
  const params = new URLSearchParams();
  if (filters.user_id) params.append('user_id', filters.user_id);
  if (filters.action) params.append('action', filters.action);
  if (filters.resource) params.append('resource', filters.resource);
  if (filters.resource_id) params.append('resource_id', filters.resource_id);
  if (filters.success !== undefined) params.append('success', filters.success.toString());
  if (filters.start_date) params.append('start_date', filters.start_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  if (filters.search) params.append('search', filters.search);
  if (filters.sort_by) params.append('sort_by', filters.sort_by);
  if (filters.sort_order) params.append('sort_order', filters.sort_order);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  const str = params.toString();
  return str ? `?${str}` : '';
}

export class AuditLogService {
  static async getAuditLogs(filters?: AuditLogFilters): Promise<AuditLogsResponse> {
    const response = await httpClient.get(`${API_BASE}${buildFilterParams(filters)}`);
    return response.json();
  }

  static async getAuditLogById(id: string): Promise<AuditLog> {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.json();
  }

  static async getAuditLogsByResource(resource: string, resourceId: string): Promise<AuditLog[]> {
    const response = await httpClient.get(`${API_BASE}/resource/${resource}/${resourceId}`);
    return response.json();
  }

  static async getAuditLogsByUser(userId: string, limit?: number): Promise<AuditLog[]> {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    const qs = params.toString();
    const response = await httpClient.get(`${API_BASE}/user/${userId}${qs ? `?${qs}` : ''}`);
    return response.json();
  }

  static async getAuditStatistics(startDate?: string, endDate?: string): Promise<AuditStatistics> {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    const qs = params.toString();
    const response = await httpClient.get(`${API_BASE}/statistics${qs ? `?${qs}` : ''}`);
    return response.json();
  }

  static async exportAuditLogs(filters?: AuditLogFilters): Promise<Blob> {
    const response = await httpClient.get(`${API_BASE}/export${buildFilterParams(filters)}`);
    return response.blob();
  }

  static async archiveOldLogs(retentionDays?: number): Promise<{ message: string; archived_count: number }> {
    const params = new URLSearchParams();
    if (retentionDays) params.append('retention_days', retentionDays.toString());
    const qs = params.toString();
    const response = await httpClient.post(`${API_BASE}/archive${qs ? `?${qs}` : ''}`);
    return response.json();
  }
}

export default AuditLogService;
